import { useEffect } from 'react';
import type { Address } from 'viem';

import { clearAgent, loadAgent } from '@/lib/hyperliquid/agent';

import { perpsUserKey } from '@/store/perps/exchange';
import { perpsAgentSelector, usePerpsSessionStore } from '@/store/perps/session';

export const getPerpsLocalAgent = (user: Address | undefined) =>
  perpsAgentSelector(user)(usePerpsSessionStore.getState()) ?? null;

/** Forgets the owner's key everywhere, so trading needs a fresh "Enable trading". */
export const discardPerpsAgent = (user: Address) => {
  clearAgent(user);
  usePerpsSessionStore.getState().setAgent(user, null);
};

/** Restores the owner's browser-held key after commit, without storing client state in Query. */
export function usePerpsLocalAgent(user: Address | undefined) {
  const agent = usePerpsSessionStore(perpsAgentSelector(user));
  useEffect(() => {
    if (!user) return;
    const session = usePerpsSessionStore.getState();
    if (!Object.hasOwn(session.agentsByUser, perpsUserKey(user))) {
      session.setAgent(user, loadAgent(user));
    }
  }, [user, agent]);
  return agent ?? null;
}
